// ToucanBru Co. — Theme JS v1.0
(function () {
  'use strict';

  // Mobile Nav
  var burger = document.getElementById('nav-burger');
  var mobileNav = document.getElementById('mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      mobileNav.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
      // Close search if open
      closeSearch();
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) {
        mobileNav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  // Search overlay
  var searchBtn    = document.getElementById('search-btn');
  var searchClose  = document.getElementById('search-close');
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput  = document.getElementById('search-input');
  var searchResults = document.getElementById('search-results');
  var searchTimer;

  window.openSearch = function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.style.display = 'block';
    searchOverlay.setAttribute('aria-hidden', 'false');
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function() { if (searchInput) searchInput.focus(); }, 50);
    // Close mobile nav if open
    if (mobileNav) mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  window.closeSearch = function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.style.display = 'none';
    searchOverlay.setAttribute('aria-hidden', 'true');
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });

  // Click outside closes search
  document.addEventListener('click', function(e) {
    if (searchOverlay && searchOverlay.style.display !== 'none') {
      if (!searchOverlay.contains(e.target) && e.target !== searchBtn && !searchBtn.contains(e.target)) {
        closeSearch();
      }
    }
  });

  // Live search
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimer);
      var q = this.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }

      searchResults.innerHTML = '<p class="search-loading">Searching...</p>';

      searchTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              searchResults.innerHTML = '<p class="search-no-results">No results for "' + q + '"</p>';
              return;
            }
            var html = '<div class="search-results-grid">';
            products.forEach(function(p) {
              var imgHtml = '';
              if (p.featured_image && p.featured_image.url) {
                imgHtml = '<img class="search-result-img" src="' + p.featured_image.url + '" alt="' + p.title + '" loading="lazy">';
              }
              var price = p.price ? formatMoney(p.price) : '';
              html += '<a href="' + p.url + '" class="search-result-item" onclick="closeSearch()">'
                + imgHtml
                + '<div class="search-result-info">'
                + '<p class="search-result-name">' + p.title + '</p>'
                + (price ? '<p class="search-result-price">' + price + '</p>' : '')
                + '</div></a>';
            });
            html += '</div>';
            html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-view-all">View all results for "' + q + '" &rarr;</a>';
            searchResults.innerHTML = html;
          })
          .catch(function() {
            searchResults.innerHTML = '<p class="search-no-results">Search unavailable right now.</p>';
          });
      }, 280);
    });

    // Submit → full search page
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && this.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(this.value.trim());
      }
    });
  }

  // Cart Toast
  var toast = document.getElementById('cart-toast');
  var toastMsg = toast ? toast.querySelector('.cart-toast__msg') : null;
  function showToast(msg) {
    if (!toast) return;
    if (toastMsg) toastMsg.textContent = msg;
    toast.style.display = 'flex';
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.style.display = 'none'; }, 4000);
  }
  function updateCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = 'BAG (' + n + ')';
    });
  }

  // AJAX Add to Cart
  function addToCart(variantId, btn) {
    if (!variantId) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (d.status === 422) throw new Error(d.description);
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      showToast('Added to bag!');
      btn.disabled = false;
      btn.textContent = orig;
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = orig;
      showToast('Could not add item. Please try again.');
    });
  }

  // Quick-add buttons on product cards
  document.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(this.dataset.variantId, this);
    });
  });

  // Product page form
  var pForm = document.getElementById('product-form');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = pForm.querySelector('[name="id"]');
      var btn = pForm.querySelector('[type="submit"]');
      if (idInput && btn) addToCart(idInput.value, btn);
    });
  }

  // Variant buttons
  var vBtns = document.querySelectorAll('.variant-btn');
  var vInput = document.getElementById('variant-id-input');
  vBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      vBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      this.classList.add('is-selected');
      if (vInput) vInput.value = this.dataset.variantId;
      var addBtn = document.querySelector('.product-form__add');
      if (addBtn) {
        var avail = this.dataset.available === 'true';
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? 'ADD TO BAG' : 'SOLD OUT';
      }
    });
  });

  // Gallery thumbnails
  var mainImg = document.getElementById('product-main-img');
  document.querySelectorAll('.product-gallery__thumb').forEach(function (th) {
    th.addEventListener('click', function () {
      document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
      if (mainImg) { mainImg.src = this.dataset.src; mainImg.alt = this.dataset.alt || ''; }
    });
  });

  // Cart quantity
  document.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(this.dataset.line, 10);
      var el = document.getElementById('qty-' + line);
      var cur = parseInt(el ? el.textContent : '1', 10);
      var qty = this.dataset.action === 'increase' ? cur + 1 : Math.max(0, cur - 1);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () { window.location.reload(); });
    });
  });

  // Cart remove
  document.querySelectorAll('.js-cart-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(this.dataset.line, 10), quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  // ── Discount Popup ────────────────────────────────────
  (function() {
    var overlay = document.getElementById('popup-overlay');
    if (!overlay) return;

    // Don't show if already dismissed this session
    if (localStorage.getItem('tb_popup_v1')) return;

    var delay = (parseInt(overlay.dataset.delay, 10) || 2) * 1000;

    var timer = setTimeout(function() {
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }, delay);

    function dismiss() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      localStorage.setItem('tb_popup_v1', '1');
      clearTimeout(timer);
    }

    var closeBtn = document.getElementById('popup-close');
    var noThanks = document.getElementById('popup-no-thanks');
    if (closeBtn) closeBtn.addEventListener('click', dismiss);
    if (noThanks) noThanks.addEventListener('click', dismiss);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) dismiss();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') dismiss();
    });

    // Form submit
    var popupForm = document.getElementById('popup-form');
    if (popupForm) {
      popupForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = popupForm.querySelector('[type="submit"]');
        btn.disabled = true;
        btn.textContent = 'SIGNING UP...';
        fetch(popupForm.action || '/contact', {
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          body: new URLSearchParams(new FormData(popupForm))
        })
        .then(function() {
          document.getElementById('popup-form-wrap').style.display = 'none';
          document.getElementById('popup-success').style.display = 'block';
          localStorage.setItem('tb_popup_v1', '1');
        })
        .catch(function() {
          btn.disabled = false;
          btn.textContent = 'CLAIM MY DISCOUNT';
        });
      });
    }

    // Copy discount code
    var copyBtn = document.getElementById('popup-copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function() {
        var code = document.getElementById('popup-code');
        if (!code) return;
        navigator.clipboard.writeText(code.textContent.trim()).then(function() {
          copyBtn.textContent = 'COPIED!';
          setTimeout(function() { copyBtn.textContent = 'COPY'; }, 2000);
        });
      });
    }
  })();


  // ── SCRATCH CARD POPUP ─────────────────────────────────
  (function() {
    var overlay = document.getElementById('sc-overlay');
    if (!overlay) return;
    if (localStorage.getItem('tb_scratch_v2')) return;

    var delay = (parseInt(overlay.dataset.delay, 10) || 3) * 1000;
    setTimeout(function() {
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      initScratch();
    }, delay);

    function closeScratch() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      localStorage.setItem('tb_scratch_v2', '1');
    }

    var closeBtn = document.getElementById('sc-close');
    if (closeBtn) closeBtn.addEventListener('click', closeScratch);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeScratch();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.style.display !== 'none') closeScratch();
    });

    // Claim button → email stage
    var claimBtn = document.getElementById('sc-claim-btn');
    if (claimBtn) {
      claimBtn.addEventListener('click', function() {
        document.getElementById('sc-s2').style.display = 'none';
        document.getElementById('sc-s3').style.display = 'flex';
      });
    }

    // Email form submit
    var scForm = document.getElementById('sc-form');
    if (scForm) {
      scForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = scForm.querySelector('[type="submit"]');
        btn.disabled = true;
        btn.textContent = 'SAVING...';
        fetch(scForm.action || '/contact', {
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          body: new URLSearchParams(new FormData(scForm))
        })
        .then(function() {
          scForm.style.display = 'none';
          var r = document.getElementById('sc-code-reveal');
          if (r) { r.style.display = 'flex'; }
          localStorage.setItem('tb_scratch_v2', '1');
        })
        .catch(function() {
          btn.disabled = false;
          btn.textContent = 'CONTINUE';
        });
      });
    }

    // Copy code
    var copyBtn = document.getElementById('sc-copy-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', function() {
        var code = document.getElementById('sc-code-text');
        if (!code) return;
        navigator.clipboard.writeText(code.textContent.trim()).then(function() {
          copyBtn.textContent = 'COPIED!';
          setTimeout(function() { copyBtn.textContent = 'COPY CODE'; }, 2000);
        });
      });
    }

    function initScratch() {
      var canvas = document.getElementById('sc-canvas');
      if (!canvas) return;

      var wrap = canvas.parentElement;
      canvas.width  = wrap.offsetWidth  || 460;
      canvas.height = wrap.offsetHeight || 220;

      var ctx = canvas.getContext('2d');
      var scratching = false;
      var revealed   = false;

      // Load the gold ToucanBru image as the scratch surface
      var goldImg = new Image();
      goldImg.crossOrigin = 'anonymous';
      goldImg.src = canvas.dataset.img || '';

      goldImg.onload = function() {
        ctx.drawImage(goldImg, 0, 0, canvas.width, canvas.height);
        // Subtle "SCRATCH HERE" hint at bottom
        ctx.fillStyle = 'rgba(255,255,255,0.55)';
        ctx.font = 'bold 16px Space Grotesk, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('✦  SCRATCH HERE  ✦', canvas.width / 2, canvas.height - 28);
      };

      goldImg.onerror = function() {
        // Fallback gold gradient if image fails
        var g = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        g.addColorStop(0,   '#8B6914');
        g.addColorStop(0.3, '#D4A017');
        g.addColorStop(0.5, '#FFD700');
        g.addColorStop(0.7, '#DAA520');
        g.addColorStop(1,   '#8B6914');
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = 'rgba(255,255,255,.65)';
        ctx.font = 'bold 16px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('SCRATCH HERE', canvas.width / 2, canvas.height / 2);
      };

      function getXY(e) {
        var r  = canvas.getBoundingClientRect();
        var sx = canvas.width  / r.width;
        var sy = canvas.height / r.height;
        var cx = e.touches ? e.touches[0].clientX : e.clientX;
        var cy = e.touches ? e.touches[0].clientY : e.clientY;
        return { x: (cx - r.left) * sx, y: (cy - r.top) * sy };
      }

      function doScratch(x, y) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(x, y, 34, 0, Math.PI * 2);
        ctx.fill();
        ctx.globalCompositeOperation = 'source-over';
        if (!revealed) checkPct();
      }

      function checkPct() {
        var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var gone = 0;
        for (var i = 3; i < d.length; i += 4) { if (d[i] < 128) gone++; }
        if (gone / (d.length / 4) > 0.52) {
          revealed = true;
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          setTimeout(function() {
            document.getElementById('sc-s1').style.display = 'none';
            document.getElementById('sc-s2').style.display = 'flex';
          }, 300);
        }
      }

      canvas.addEventListener('mousedown',  function(e){ scratching=true; var p=getXY(e); doScratch(p.x,p.y); });
      canvas.addEventListener('mousemove',  function(e){ if(scratching){ var p=getXY(e); doScratch(p.x,p.y); }});
      canvas.addEventListener('mouseup',    function(){ scratching=false; });
      canvas.addEventListener('mouseleave', function(){ scratching=false; });
      canvas.addEventListener('touchstart', function(e){ e.preventDefault(); scratching=true; var p=getXY(e); doScratch(p.x,p.y); },{passive:false});
      canvas.addEventListener('touchmove',  function(e){ e.preventDefault(); if(scratching){ var p=getXY(e); doScratch(p.x,p.y); }},{passive:false});
      canvas.addEventListener('touchend',   function(){ scratching=false; });
    }
  })();

})();
/* ── Overlay header: turn solid once scrolled past the hero ── */
(function () {
  var header = document.getElementById('site-header');
  if (!header || !header.classList.contains('is-overlay')) return;
  var hero = document.querySelector('.hero-fw');
  function onScroll() {
    var trigger = hero ? (hero.offsetHeight - 90) : 420;
    if (window.pageYOffset > trigger) header.classList.add('is-solid');
    else header.classList.remove('is-solid');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
})();

/* ── Collection filter bar (client-side, reads product data) ── */
(function () {
  var grid = document.querySelector('[data-grid]');
  if (!grid) return;
  var items = Array.prototype.slice.call(grid.querySelectorAll('.cf-item'));
  if (!items.length) return;
  var originalOrder = items.slice();
  var countEl  = document.querySelector('[data-count]');
  var noRes    = document.querySelector('[data-noresults]');
  var activeEl = document.querySelector('[data-active]');
  var chipsEl  = document.querySelector('[data-chips]');
  var sortSel  = document.querySelector('[data-sort]');
  var dds      = Array.prototype.slice.call(document.querySelectorAll('[data-dd]'));
  var checks   = Array.prototype.slice.call(document.querySelectorAll('[data-facet]'));

  dds.forEach(function (dd) {
    var btn = dd.querySelector('[data-dd-btn]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = dd.classList.contains('is-open');
      dds.forEach(function (d) { d.classList.remove('is-open'); });
      if (!open) dd.classList.add('is-open');
    });
    var panel = dd.querySelector('.cf-dd__panel');
    if (panel) panel.addEventListener('click', function (e) { e.stopPropagation(); });
  });
  document.addEventListener('click', function () { dds.forEach(function (d) { d.classList.remove('is-open'); }); });

  function selected(facet) {
    return checks.filter(function (c) { return c.dataset.facet === facet && c.checked; })
                 .map(function (c) { return c.value; });
  }
  function tokens(str) { str = (str || '').trim(); return str.length ? str.split(/\s+/) : []; }
  function some(arr, set) { return arr.some(function (v) { return set.indexOf(v) > -1; }); }

  function apply() {
    var sp = selected('sport'), ty = selected('type'), sz = selected('size'), cl = selected('club'), os = selected('othersport');
    var shown = 0;
    items.forEach(function (it) {
      var ok = true;
      if (sp.length && !some(sp, tokens(it.getAttribute('data-sport')))) ok = false;
      if (ok && ty.length && ty.indexOf(it.getAttribute('data-type') || '') < 0) ok = false;
      if (ok && sz.length && !some(sz, tokens(it.getAttribute('data-size')))) ok = false;
      if (ok && cl.length && !some(cl, tokens(it.getAttribute('data-club')))) ok = false;
      if (ok && os.length && !some(os, tokens(it.getAttribute('data-othersport')))) ok = false;
      it.classList.toggle('is-hidden', !ok);
      if (ok) shown++;
    });
    if (countEl) countEl.textContent = shown + (shown === 1 ? ' Product' : ' Products');
    if (noRes) noRes.hidden = shown !== 0;
    updateLabels();
    updateChips();
  }

  function updateLabels() {
    dds.forEach(function (dd) {
      var txt = dd.querySelector('[data-dd-text]');
      if (!txt) return;
      var n = selected(dd.getAttribute('data-facet-group')).length;
      txt.textContent = n ? txt.getAttribute('data-base') + ' (' + n + ')' : txt.getAttribute('data-base');
    });
  }

  function labelOf(input) {
    var opt = input.closest('.cf-opt');
    var span = opt ? opt.querySelector('span') : null;
    return span ? span.textContent : input.value;
  }
  function updateChips() {
    if (!chipsEl || !activeEl) return;
    chipsEl.innerHTML = '';
    var active = checks.filter(function (c) { return c.checked; });
    activeEl.hidden = active.length === 0;
    active.forEach(function (c) {
      var chip = document.createElement('span'); chip.className = 'cf-chip';
      var lab = document.createElement('span'); lab.textContent = labelOf(c); chip.appendChild(lab);
      var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Remove'); x.textContent = '\u00d7';
      x.addEventListener('click', function () { c.checked = false; apply(); });
      chip.appendChild(x); chipsEl.appendChild(chip);
    });
  }

  checks.forEach(function (c) { c.addEventListener('change', apply); });
  Array.prototype.slice.call(document.querySelectorAll('[data-clear]')).forEach(function (b) {
    b.addEventListener('click', function () { checks.forEach(function (c) { c.checked = false; }); apply(); });
  });

  if (sortSel) sortSel.addEventListener('change', function () {
    var v = sortSel.value, arr = originalOrder.slice();
    if (v === 'price-asc')       arr.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
    else if (v === 'price-desc') arr.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
    else if (v === 'title-asc')  arr.sort(function (a, b) { return (a.dataset.title || '').localeCompare(b.dataset.title || ''); });
    arr.forEach(function (it) { grid.appendChild(it); });
  });
})();

/* Product image zoom: hover-pan (desktop) + tap lightbox (mobile/all) */
(function () {
  function initZoom() {
    var wrap = document.querySelector('.product-gallery__main');
    var img = document.getElementById('product-main-img');
    if (!wrap || !img) return;
    var ZOOM = 2.4, base = null;

    wrap.addEventListener('mouseenter', function () {
      img.style.transform = '';
      base = img.getBoundingClientRect();
    });
    wrap.addEventListener('mousemove', function (e) {
      if (!base || !base.width) base = img.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, ((e.clientX - base.left) / base.width) * 100));
      var y = Math.min(100, Math.max(0, ((e.clientY - base.top) / base.height) * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(' + ZOOM + ')';
    });
    wrap.addEventListener('mouseleave', function () {
      img.style.transform = '';
      img.style.transformOrigin = 'center center';
      base = null;
    });

    function openLightbox(src) {
      var ov = document.createElement('div');
      ov.className = 'img-lightbox';
      var big = document.createElement('img');
      big.src = src;
      ov.appendChild(big);
      var hint = document.createElement('div');
      hint.className = 'img-lightbox__hint';
      hint.textContent = 'Tap image to zoom \u00B7 tap background to close';
      ov.appendChild(hint);
      big.addEventListener('click', function (ev) { ev.stopPropagation(); big.classList.toggle('zoomed'); });
      ov.addEventListener('click', function () { document.body.style.overflow = ''; ov.remove(); });
      document.body.appendChild(ov);
      document.body.style.overflow = 'hidden';
    }
    // Tap on a touch device (or click on desktop) opens the full-screen view
    wrap.addEventListener('click', function () {
      if (window.matchMedia('(hover:none)').matches) openLightbox(img.src);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initZoom);
  else initZoom();
})();
